// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomPage_container__1DkPK","containerSmall":"CustomPage_containerSmall__3x1sE"};